// extracted by mini-css-extract-plugin
export default {"button":"UserRoleChange-button-b514e243ef079f508eebac36a7ee6ed9","arrowsIcon":"UserRoleChange-arrowsIcon-3aa7fba95a7c19a91297782b7c1b3057"};